import StorefrontApiManager from '../core/api/StorefrontApiManager';
import {createApiClient} from '../common/network/apiUtils';

import config from '../conf/config.js';

const DEFAULT_CLIENT_SIDE_NETWORK_TIMEOUT = 8000;
// 3000 default

const storefrontApiManager = new StorefrontApiManager({
  baseURL: window.apiBaseUrl || config.api,
  timeout: DEFAULT_CLIENT_SIDE_NETWORK_TIMEOUT,
});

const clientApiManager = createApiClient(storefrontApiManager);

export default clientApiManager;



// WEBPACK FOOTER //
// ./src/service/clientApiManager.js